/**
 * Holds any contexts used in the app.
 * ! Contexts be in a separate file, due to ES6 imports.
 */

import { createContext } from 'react'

export const UserContext = createContext( {} )
